{
  "dismissedMessage": "Demande refusée pour « {{tailNumber}} »",
  "dismissError": "Échec du rejet de la demande. Veuillez réessayer.",
  "emptyState": "Aucune demande d'immatriculation en attente",
  "unknown": "Inconnu",
  "headers": {
    "tailNumber": "Immatriculation",
    "fboName": "Nom du FBO",
    "requestedBy": "Demandé par",
    "requestedAt": "Demandé le",
    "actions": "Actions"
  },
  "dismissTooltip": "Ignorer cette demande"
}
